import {performGQL} from "../functions";
import generateQuery from "../../../graphql/generate-query";

function getMortgage(id) {
    const query = generateQuery('GetUserMortgage', `
    id
    offlineAssocEmail
    twoApplicants
    mortgageType
    applicationType
    activeAgent
    subs
    applicant1ID
    applicant2ID
    friendlyName
    data
    applicationStage
    applicationStatus
    applicationFutureDate
    qualification
    adminMessage
    adminMessageBy
    adminMessageOn
    supportMessage
    supportMessageBy
    supportMessageOn
    qualificationConfirmed
    qualificationReason
    lastSeen
    lastFlowItem
    lastFlowItemTime,
    completedFlowItems
    completedFlowItemsForAdmin
    completedFlowHiddenItems
    completedFlowItemsMeta
    advisorID
    caseNumber
     uploadsPercentSetup
    uploadsPercentApply
    uploadsPercentPreapproval
    uploadsPercentApproval
    questionPercentApp1Setup
    questionPercentApp2Setup
    questionPercentApp1Apply
    questionPercentApp2Apply
    questionPercentGeneralSetup
    questionPercentGeneralApply
     mpi {
        id
        mortgageID
        provider
        policyNumber
        applicationAccepted
        policyStartDate
        underwritingOutcome
        underwritingOutcomeOn
        quoteGenerated
        quoteGeneratedOn
        quoteGeneratedBy
        createdAt
        updatedAt
        _version
      }
    aiResponses {
        items {
          id
          mortgageID
          responseName
          chatGptResponse
          reaction
          reactionOn
          reactionBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      figuresTests {
        items {
          id
          mortgageID
          status
          options
          figures
          testName
          readAccessGroup
          editAccessGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          owner
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      figuresTestFlows {
        items {
          id
          mortgageID
          status
          testName
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
    docContents {
        items {
            id
            mortgageID
            paragraph
            folder
            document
            sequence
            html
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            __typename
          }
          nextToken
        startedAt
        __typename
    }
    submissions {
        items {
          id
          amortisationAfterFixedTerm
          lenderCode
          provisionalProduct
          provisionalRateId
          provisionalRate
          provisionalTerm
          provisionalTermPlusMonths
          provisionalFixedTerm
          provisionalLoan
          provisionalValue
          provisionalSecondaryProduct
          provisionalSecondaryRate
          provisionalSecondaryRateId
          provisionalSecondaryFixedTerm
          provisionalXlsInput
          provisionalXlsOutput
          provisionalFixedTerm
          provisionalRateModel {
            id
            rate
            term
            product
           promotions
            conditions
          }
          finalProduct
          finalRate
          finalRateId
          finalFixedTerm
          finalTerm
          finalTermPlusMonths
          finalLoan
          finalValue
          finalSecondaryProduct
          finalSecondaryRate
          finalSecondaryRateId
          finalSecondaryFixedTerm
          finalRateModel {
            id
            rate
            term
            product
           promotions
            conditions
          }
          finalXlsInput
          finalXlsOutput
          finalFixedTerm
          soft
          aipEmailId
          aipEmail{
            id
            from
          
          }
          aipMaxLoan
          aipTerm
          aipTermPlusMonths
          aipPropertyReference
          aipExpiryDate
          aipDate
          aipNotes
          aipSettings
          expectedAipDate
          loanOfferEmailId
          loanOfferEmail{
              id
            from
          
          }
          loanOfferDate
          loanOfferExpiryDate
          loanOfferNotes
          loanOfferSettings
          drawdownDate
          completedFlowItems
          completedFlowItemsForAdmin
          
          lenderRecommendation
          productRecommendation
          mortgageAccountNo
          termRecommendation
          invalidatedReason
          mpiStartDate
          mpiProvider
          mpiPolicyNo
          mortgageID
       
          verifiedFiguresTest {
        id
        lenderCode
        mortgageID
        testID
        test {
          id
          flowID
          mortgageID
          value
          loan
          term
          lenders
          variableUsed
          incomeUsed
          figures
          status
          verifiedFiguresUsed
          testName
          tests {
            items {
              id
              lenderCode
              mortgageID
              testID
              loan
              term
              value
              status
              output
              passed
              bof
              fileUrl
              limitedBy
                                cashForLiving
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              __typename
            }
            nextToken
            startedAt
            __typename
          }
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        loan
        term
        value
        status
        output
        passed
        fileUrl
        limitedBy
                                cashForLiving
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
          verifiedFiguresTestID
          readAccessGroup
          editAccessGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          owner
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      
   playgroundTests {
        items {
          id
          mortgageID
          results
          data
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
    lenderTests {
        items {
          id
          lenderCode
          mortgageID
          results
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
    replyRequests {
        items {
          id
          receivedOn
          mortgageId
          emailId
          requestBody
          requestType
          assocEmails
          noteBody
          repliedBy
          repliedOn
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
    notifications{
        items{
            id
            mortgageID
            stage
            name
            history{
                items{
                    id
                    sentTime
                    sentBy
                    data
                    notificationId
                    createdAt
                    updatedAt
                    _version
                    _deleted
                    _lastChangedAt
                }
                nextToken
                startedAt
            }
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
        }
        nextToken
        startedAt
    }
    queries {
        items {
          id
          mortgageID
          createdBy
          referenceType
          referenceId
          section
          index
          reoccurring
          adjustmentDirection
          adjustmentAmount
          adjustmentList
          title
          date
          description
          amount
          query
          stage
          adminAnswered
          userAnswered
          userAnswer
          userAnswerOn
          userAnswerBy
          lenderAnswer
          lenderAnswerOn
          lenderAnswerBy
          excludedOn
          excludedBy
          private
          emailReplyID
          readAccessGroup
          editAccessGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          owner
          __typename
        }
        nextToken
        startedAt
        __typename
      }
    requirement {
        id
        accountingFx
        preferredMortgagePaymentDay
        maxLoanTested
        savingsRateFxRates
        statementAlignmentDate
        ddBankAccountID
        ddBankAccountIsNew
        ddBankAccountDetails
        applicationElsewhere
        loanRequired
        loanAmountKnown
        lenderCode
        gifters
        mortgageAccountNo
        drawdownDate
        cohabiting
        loanTerm
        rateId
        rate
        monthlyPayment
        finalRate
        finalTerm
        firstTimeBuyers
        combinedDependants
        combinedGrossEarnings
        combinedLoanRepayments
        depositSavings
        depositGifts
        helpToBuyScheme
        helpToBuySchemeAmount
        helpToBuySchemeAccessCode
        helpToBuySchemeApplicationCode
        helpToBuySchemeDeveloperName
        helpToBuyExpiryDate
        proposals
        firstHomeScheme
        firstHomeSchemeCouncil
        firstHomeSchemeType
        firstHomeSchemeAmount
        price
        hasLoans
        hasCards
        receivingGifts
        readAccessGroup
        editAccessGroup
        createdAt
        updatedAt
        lenderId
        lenderProduct
        loanOfferDate
        loanOfferExpiryDate
        hasOwnMPI
        aipDate
        aipExpiryDate
        drawdownDate
        propertyReference
        mortgageAccountNo
        contactMethod
        mpiShortfallLetterRequired
        soft
        _version
        _deleted
        _lastChangedAt
        owner
    }
    appointments {
        items {
          id
          backendUserID
          appointmentType
          expired
          appointmentDate
          mortgageID
          readAccessGroup
          editAccessGroup
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          owner
          __typename
        }
        nextToken
        startedAt
        __typename
      }
    property {
        id
        intendedUse
        addressKnown
        propertyType
        address
        newlyBuilt
        bedrooms
        bathrooms
        spendAmount
        purchasePrice
        propertyValue
        monthlyRent
        residingHere
        yearOfPurchase
        adultsBoarding
        adultsBoardingCount
        berScore
        purchaseStage
        mortgageID
        readAccessGroup
        editAccessGroup
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        owner
    }
    properties {
        items {
            id
            addressKnown
            address
            propertyType
            buildType
            newlyBuilt
            propertyAge
            bedrooms
            bathrooms
            berScore
            propertyValue
            propertyPrice
            origPurchasePrice
            yearOfPurchase
            residingHere
            adultsBoarding
            adultsBoardingCount
            isRented
            monthlyRent
            isMortgaged
            isNewAccount
            isClosed
            remainingTerm
            lender
            accountNumber
            monthlyPayment
            currentRate
            outstanding
            reinstatementValue
          valuationValue
          valuationInstructed
          valuationDate
          valuationExpiryDate
          anotherValuationNeeded
          hasValuationIssues
          valuationIssues
          valuation2Instructed
          valuation2Date
          valuation2ExpiryDate
          valuation2ReinstatementValue
          reinstatement2Value
          valuation2Value
          hasValuation2Issues
          valuation2Issues
          valuationExpectedCompletion
          valuation2ExpectedCompletion
          surveyRequired
          surveyDate
          siteOwned
            siteValue
            constructionCosts
            constructionStarted
            bookingDepositPaid
            contractDepositPaid
            berDiscussed
            snagDate
  berReference
  berExpiryDate
  berEmissions
  berKwhPerM2
  berDateOfIssue
  berExemptionConfirmed
            
            agentFirstName
            agentLastName
            agentCompanyName
            agentCompanyAddress
            
            mortgageID
            readAccessGroup
            editAccessGroup
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            owner
        }
        nextToken
        startedAt
    }
    existing {
        id
        remainingTerm
        lender
        accountNumber
        monthlyPayment
        currentRate
        outstanding
        topUpRequired
        topUpPurpose
        topUpAmount
        readAccessGroup
        editAccessGroup
        propertyId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        owner
    }
    needs {
        id
        circumstanceChanges
        circumstanceChangesDetails
        healthIssues
        healthIssuesDetails
        policeRecord
        policeRecordDetails
        incomeChange
        expenditureChange
        moveLikely
        plannedPayOff
        beyondRetirement
        speedEssential
        consolidatingDebt
        furtherRequirements
        furtherRequirementsDetails
        readAccessGroup
        editAccessGroup
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        owner
    }
    uploads {
        items {
            id
            advisorAlert
            legacyNoIndex
            contentType
            fileName
            fileSize
            fileExtension
            stage
            section
            verifiable
            index
            status
            statusBy
            statusOn
            mortgageID
            observeMID
            reason
            identityID
            stampedOn
            analysisJobStatus
            analysisErrors
            processedAnalysis
            pdffed
            seenOn
            seenBy
            omit
            exclude
            logicalName
            examined
            examinedBy
            readAccessGroup
            editAccessGroup
            createdAt
            updatedAt
            documentDate
            endDate
            startDate
            balances {
                items {
                  id
                  uploadID
                  date
                  balance
                  dirty
                  balanceBoundary
                  createdAt
                  updatedAt
                  _version
                  _deleted
                  _lastChangedAt
                  owner
                  __typename
                }
                nextToken
                startedAt
                __typename
              }
            _version
            _deleted
            _lastChangedAt
            owner
              verifiedData {
        items {
          id
          uploadID
          mortgageID
          name
          verifiedValue
          verifiedValueType
          verificationOn
          verificationBy
          verificationNotes {
            items {
              id
              verificationID
              authorID
              string
              createdAt
              updatedAt
              _version
              _deleted
              _lastChangedAt
              __typename
            }
            nextToken
            startedAt
            __typename
          }
          supervisorCheckRequired
          supervisorCheckOn
          supervisorCheckBy
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        nextToken
        startedAt
        __typename
      }
            
        }
        nextToken
        startedAt
    }
    progress {
        items {
            id
           requiredRanges {
            start
            end
          }
          requiredRangesAuthor
          userStages
            applicationStage
            sectionType
            sectionName
            sectionIndex
            percent
            mortgageID
            percentUpdatedAt
            alertTitle
            alertBody
            alertAuthor
            alertDismissed
            alertDone
            alertPending
            sectionChecked
            sectionCheckedBy
            sectionUserComplete
            expiresDate
            isNewAccount
            note
            submittedOn
            submittedBy
            arrangement
            metaData
            verifiedData
            excludeFromCalculations
            includeInCalculations
            internalNote
            internalNoteBy
            internalNoteOn
            firstDocumentDate
            lastDocumentDate
            lastDocumentDateDismissed
            viewState
viewStateBy
viewStateOn
report
reportTime
reportBy
            readAccessGroup
            editAccessGroup
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            owner
        }
        nextToken
        startedAt
    }
    applicant1 {
        id
        subjectId
        identityID
        email
        mobile
        firstName
        surname
        isMale
        lastHere
        data
        userApplicantPersonalId
        userApplicantIncomeId
        userApplicantFinancialId
        userApplicantEmploymentId
        userApplicantTaxId
        userApplicantLastHereId
        lastHereTime{
            id
            time
            readAccessGroup
            editAccessGroup
            createdAt
            updatedAt
            _version
        }
        personal {
            id
            title
            dateOfBirth
            maritalStatus
            maidenName
            hasCriticalSkillsPermit
            mothersMaidenName
            nationality
            countryOfBirth
            placeOfBirth
            countryOfResidence
            countDependents
            dependentAges
            dependentDOBs
            accommodationSituation
            accommodationSituationOther
            addressCurrent
            addressCurrentYears
            addressCurrentStartDate
            addressPrevious
            irishResidenceStartDate
            otherCountryOfResidenceInPast3Years
            dualResidency
            visaRequired
            proofOfAddressRequired
            readAccessGroup
            editAccessGroup
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            owner
        }
        health {
            id
            weight
            height
            smoker
            cigarettesSmoked
            cigarettesPerDay
            cigarSmoked
            cigarsPerDay
            pipeSmoked
            pipeGramsPerDay
            electronicCigaretteSmoked
            otherNicotineReplacementUsed
            everSmoked
            stoppedSmokingDate
            alcoholUnits
            dangerousActivities
            dangerousActivitiesDetails
            familyDeath
            familyDeathDetails
            diagnosedConditions
            diagnosedConditionsDetails
            prescribedMedication
            prescribedMedicationDetails
            hasGp
            gpName
            gpAddress
            gpLastVisit
            gpLastVisitYearsAgo
            yearsWithGp
            electronicCigarettesPerDay
            otherNicotineReplacementPerDay
            otherTobacco
            otherTobaccoPerDay
            diagnosedConditionSelections
            familyMedicalHistory
            gpPhone
            previousGpName
            previousGpAddress
            previousGpPhone
            advisedToReduceAlcohol
            alcoholOrDrugSupport
            recreationalDrugUse
            medicationMisuse
            alcoholDrugDetails
            followUpReviews
            specialistReferral
            followUpDetails
            recentSymptoms
            recentSymptomsDetails
            travelOutsideRegions
            travelDetails
            existingSeriousIllnessCover
            existingIncomeProtectionCover
            incomeProtectionBeingReplaced
            existingLifeCover
            existingCoverDetails
            bpAwaitingTests
            bpComplications
            bpOnTreatment
            bpStoppedTreatment
            bpFirstRaisedDate
            bpKnowsLastReading
            bpLastReadingSystolic
            bpLastReadingDiastolic
            bpLastReadingAssessment
            bpLastReviewOutcome
            cholesterolAwaitingTests
            cholesterolComplications
            cholesterolFirstRaisedDate
            cholesterolFamilyHistory
            cholesterolOnTreatment
            cholesterolMedicationCount
            cholesterolStoppedTreatment
            cholesterolKnowsLastReading
            cholesterolLastReading
            cholesterolLastReadingAssessment
            cholesterolLastReviewOutcome
            cholesterolCheckFrequency
            mentalHealthEverHad
            mentalHealthLast5Years
            mentalHealthAwaitingReferral
            selfHarmHistory
            mentalHealthLastSymptomsDate
            mentalHealthProfessionalsSeen
            mentalHealthLastTimeOffWork
            mentalHealthEpisodes
            mentalHealthCurrentTreatment
            hadCancer
            cancerConditions
            cancerDiagnosisDate
            cancerLastTreatmentDate
            cancerInRemission
            cancerPrincipalResidence
            cancerExistingResidenceCover
            cancerExistingCoverCancelled
            cancerOnlyApplication
            cancerOtherCoverDetails
            cancerCoverExceedsMortgage
            hazardousIndustries
            workActivities
            manualWorkPercent
            manualDuties
            businessDrivingKmPerYear
            workingAtHeightsPercent
            workingAtHeightsTypicalFeet
            sicknessAffectingWork
            sicknessAffectingWorkDetails
            legacyPolicyConfig
            earlyUnderwriting
            readAccessGroup
            editAccessGroup
            createdAt
            updatedAt
            _version
            _deleted
        }
        income {
            id
            grossBasic
            hasOvertime
            overtime
            hasBonus
            bonus
            hasCommission
            commission
            hasOther
            other
            otherSource
            otherSourceDetails
            nonEuroCurrency
            maintenance
            welfare
            secondjob
            rentalIncome
            dividends
            selfIncomeSource
            salariedInstitution
            incomeChecks
            payFrequency
            readAccessGroup
            editAccessGroup
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            owner
        }
        financial {
            id
            hasAccommodationCosts
            monthlyAccommodationCosts
            hasChildcareCosts
            contributeToRelatives
            negativeCredit
            hasCurrentAccountSavings
            hasLoans
            hasSavings
            hasAssets
            hasDebts
            hasIncome
            hasProperties
            hasOverdraft
            paysMaintenance
            maintenanceCosts
            monthlyChildcareCosts
            monthlySavings
            confirmedMonthlySavings
            monthlyChildrenAllowance
            monthlyOtherAllowance
            readAccessGroup
            editAccessGroup
            report
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            owner
        }
        employment {
            id
            primaryEmploymentId
            employmentType
            currentEmployerName
            currentEmployerAddress
            currentEmployerPhone
            currentEmployerYearsThere
            currentEmployerContact
            previousEmployerName
            previousEmployerAddress
            previousEmployerYearsThere
            positionHeld
            nameOfBusiness
            natureOfBusiness
            businessAddress
            accountantName
            accountantAddress
            accountantPhone
            businessEstablished
            employmentBasis
            limitedCompany
            isDirector
            percentageOfShares
            currentEmployerStartDate
            previousEmploymentBasis
            previousPositionHeld
            previousEmployerStartDate
            previousEmployerEndDate
            readAccessGroup
            editAccessGroup
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            owner
        }
        employmentIncome {
          items {
            id
            applicantID
            employmentType
            employmentBasis
            positionHeld
            currentEmployerName
            currentEmployerAddress
            currentEmployerPhone
            currentEmployerContact
            currentEmployerStartDate
            firstJob
            maternityLeave
            usingPayscale
            previousEmployerName
            previousEmployerAddress
            previousPositionHeld
            previousEmploymentBasis
            previousEmployerStartDate
            previousEmployerEndDate
            nameOfBusiness
            natureOfBusiness
            businessAddress
            businessBankName
            businessBankAccountNumber
            accountantName
            accountantAddress
            accountantPhone
            businessEstablished
            limitedCompany
            isDirector
            percentageOfShares
            selfIncomeSource
            grossBasic
            incomes
            payFrequency
            publicSector
            nonEuroCurrency
            
            
            usingBikAmount
            usingShareSaveAmount
            usingAvcAmount
  
            nextPayScale1
              nextPayScale2
              nextPayScale3
              nextPayScaleConfirmedDate
  contractRequired
            readAccessGroup
            editAccessGroup
            
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            owner
      
          }
          nextToken
         
        }
        tax {
            id
            irishTaxResident
            ppsNumber
            usCitizen
            usTaxId
            otherTaxResident
            otherTaxCountry
            otherTaxId
            readAccessGroup
            editAccessGroup
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            owner
        }
        accounts {
          items {
            id
            institution
            applicantID
            salaried
            joint
            isNewAccount
            isClosed
            accommodationDD
            currency
            accountNumber
            maskedAccountNumber
            updateAtApproval
            updateAtPreApproval
            accountName
            accountAddress
            lastDocumentDate
            hasOverdraft
            overdraftLimit
            highestCreditUtilisation
            readAccessGroup
            editAccessGroup
            createdAt
            updatedAt
            progressID
            _version
            _deleted
            _lastChangedAt
            owner
            __typename
          }
          nextToken
        }
        assets {
            items {
                id
                assetType
                institution
                description
                balance
                joint
                increasesFrequency
                increases
                applicantID
                observeMID
                currency
                accountNumber
                accountName
                accountAddress
                lastDocumentDate
                readAccessGroup
                editAccessGroup
                isNewAccount
                isClosed
                progressID
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                owner
            }
            nextToken
            startedAt
        }
        properties {
            items {
                id
                toBeSold
                residingHere
                propertyType
                address
                estimatedValue
                isRented
                rentPerAnnum
                rentPerMonth
                isMortgaged
                isNewAccount
                isClosed
                accountNumber
                outstanding
                monthlyRepayments
                remainingTerm
                lender
                inArrears
                arrears
                applicantID
                bedrooms
                bathrooms
                isRestructured
                originalAmount
                observeMID
                endDate
                currency
                lastDocumentDate
                readAccessGroup
                editAccessGroup
                progressID
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                owner
            }
            nextToken
            startedAt
        }
        debts {
            items {
                id
                debtType
                lender
                outstanding
                monthlyPayment
                creditLimit
                highestCreditUtilisation
                inArrears
                arrears
                endDate
                originalAmount
                currency
                clearedBeforeMortgage
                applicantID
                observeMID
                accountNumber
                isNewAccount
                isClosed
                lastDocumentDate
                readAccessGroup
                editAccessGroup
                progressID
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                owner
            }
            nextToken
            startedAt
        }
                                 
        alternateEmailAddresses {
            items {
                id
                email
                applicantID
                readAccessGroup
                editAccessGroup
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                owner
            }
            nextToken
            startedAt
        }
        readAccessGroup
        editAccessGroup
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        owner
    }
    applicant2 {
        id
        subjectId
        identityID
        email
        mobile
        firstName
        surname
        isMale
        lastHere
        data
        userApplicantPersonalId
        userApplicantIncomeId
        userApplicantFinancialId
        userApplicantEmploymentId
        userApplicantTaxId
        userApplicantLastHereId
        lastHereTime{
            id
            time
            createdAt
            updatedAt
            readAccessGroup
            editAccessGroup
            _version
        }
        personal {
            id
            title
            dateOfBirth
            maritalStatus
            maidenName
            mothersMaidenName
            nationality
            countryOfBirth
            placeOfBirth
            hasCriticalSkillsPermit
            countryOfResidence
            countDependents
            dependentAges
            dependentDOBs
            accommodationSituation
            accommodationSituationOther
            addressCurrent
            addressCurrentYears
            addressCurrentStartDate
            addressPrevious
            irishResidenceStartDate
            otherCountryOfResidenceInPast3Years
            dualResidency
            visaRequired
            proofOfAddressRequired
            readAccessGroup
            editAccessGroup
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            owner
        }
        health {
            id
            weight
            height
            smoker
            cigarettesSmoked
            cigarettesPerDay
            cigarSmoked
            cigarsPerDay
            pipeSmoked
            pipeGramsPerDay
            electronicCigaretteSmoked
            otherNicotineReplacementUsed
            everSmoked
            stoppedSmokingDate
            alcoholUnits
            dangerousActivities
            familyDeath
            familyDeathDetails
            diagnosedConditions
            diagnosedConditionsDetails
            prescribedMedication
            prescribedMedicationDetails
            hasGp
            gpName
            gpAddress
            gpLastVisit
            gpLastVisitYearsAgo
            yearsWithGp
            electronicCigarettesPerDay
            otherNicotineReplacementPerDay
            otherTobacco
            otherTobaccoPerDay
            diagnosedConditionSelections
            familyMedicalHistory
            gpPhone
            previousGpName
            previousGpAddress
            previousGpPhone
            advisedToReduceAlcohol
            alcoholOrDrugSupport
            recreationalDrugUse
            medicationMisuse
            alcoholDrugDetails
            followUpReviews
            specialistReferral
            followUpDetails
            recentSymptoms
            recentSymptomsDetails
            travelOutsideRegions
            travelDetails
            existingSeriousIllnessCover
            existingIncomeProtectionCover
            incomeProtectionBeingReplaced
            existingLifeCover
            existingCoverDetails
            bpAwaitingTests
            bpComplications
            bpOnTreatment
            bpStoppedTreatment
            bpFirstRaisedDate
            bpKnowsLastReading
            bpLastReadingSystolic
            bpLastReadingDiastolic
            bpLastReadingAssessment
            bpLastReviewOutcome
            cholesterolAwaitingTests
            cholesterolComplications
            cholesterolFirstRaisedDate
            cholesterolFamilyHistory
            cholesterolOnTreatment
            cholesterolMedicationCount
            cholesterolStoppedTreatment
            cholesterolKnowsLastReading
            cholesterolLastReading
            cholesterolLastReadingAssessment
            cholesterolLastReviewOutcome
            cholesterolCheckFrequency
            mentalHealthEverHad
            mentalHealthLast5Years
            mentalHealthAwaitingReferral
            selfHarmHistory
            mentalHealthLastSymptomsDate
            mentalHealthProfessionalsSeen
            mentalHealthLastTimeOffWork
            mentalHealthEpisodes
            mentalHealthCurrentTreatment
            hadCancer
            cancerConditions
            cancerDiagnosisDate
            cancerLastTreatmentDate
            cancerInRemission
            cancerPrincipalResidence
            cancerExistingResidenceCover
            cancerExistingCoverCancelled
            cancerOnlyApplication
            cancerOtherCoverDetails
            cancerCoverExceedsMortgage
            hazardousIndustries
            workActivities
            manualWorkPercent
            manualDuties
            businessDrivingKmPerYear
            workingAtHeightsPercent
            workingAtHeightsTypicalFeet
            sicknessAffectingWork
            sicknessAffectingWorkDetails
            legacyPolicyConfig
            earlyUnderwriting
            readAccessGroup
            editAccessGroup
            createdAt
            updatedAt
            _version
            _deleted
        }
        income {
            id
            grossBasic
            hasOvertime
            overtime
            hasBonus
            bonus
            hasCommission
            commission
            hasOther
            other
            otherSource
            otherSourceDetails
            nonEuroCurrency
            maintenance
            welfare
            secondjob
            rentalIncome
            dividends
            selfIncomeSource
            salariedInstitution
            incomeChecks
            payFrequency
            readAccessGroup
            editAccessGroup
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            owner
        }
        financial {
            id
            hasAccommodationCosts
            monthlyAccommodationCosts
            hasChildcareCosts
            contributeToRelatives
            negativeCredit
            hasLoans
            hasSavings
            hasAssets
            hasDebts
            hasIncome
            hasProperties
            hasOverdraft
            paysMaintenance
            maintenanceCosts
            monthlyChildcareCosts
            monthlySavings
            confirmedMonthlySavings
            monthlyChildrenAllowance
            monthlyOtherAllowance
            readAccessGroup
            editAccessGroup
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            owner
        }
        employment {
            id
            primaryEmploymentId
            employmentType
            currentEmployerName
            currentEmployerAddress
            currentEmployerPhone
            currentEmployerYearsThere
            currentEmployerContact
            previousEmployerName
            previousEmployerAddress
            previousEmployerYearsThere
            positionHeld
            nameOfBusiness
            natureOfBusiness
            businessAddress
            accountantName
            accountantAddress
            accountantPhone
            businessEstablished
            employmentBasis
            limitedCompany
            isDirector
            percentageOfShares
            currentEmployerStartDate
            previousEmploymentBasis
            previousPositionHeld
            previousEmployerStartDate
            previousEmployerEndDate
            readAccessGroup
            editAccessGroup
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            owner
        }
        employmentIncome {
          items {
            id
            applicantID
            employmentType
            employmentBasis
            positionHeld
            currentEmployerName
            currentEmployerAddress
            currentEmployerPhone
            currentEmployerContact
            currentEmployerStartDate
            firstJob
            usingPayscale
             nextPayScale1
              nextPayScale2
              nextPayScale3
              nextPayScaleConfirmedDate
            previousEmployerName
            previousEmployerAddress
            previousPositionHeld
            previousEmploymentBasis
            previousEmployerStartDate
            previousEmployerEndDate
            nameOfBusiness
            natureOfBusiness
            businessAddress
            businessBankName
            businessBankAccountNumber
            accountantName
            accountantAddress
            accountantPhone
            businessEstablished
            limitedCompany
            isDirector
            percentageOfShares
            selfIncomeSource
            grossBasic
            incomes
            payFrequency
            publicSector
            nonEuroCurrency
            contractRequired
            readAccessGroup
            editAccessGroup
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            owner
      
          }
          nextToken
         
        }
        tax {
            id
            irishTaxResident
            ppsNumber
            usCitizen
            usTaxId
            otherTaxResident
            otherTaxCountry
            otherTaxId
            readAccessGroup
            editAccessGroup
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            owner
        }
        accounts {
          items {
            id
            institution
            applicantID
            salaried
            joint
            accommodationDD
            readAccessGroup
            editAccessGroup
            currency
            accountNumber
            maskedAccountNumber
            updateAtApproval
            updateAtPreApproval
            accountName
            accountAddress
            lastDocumentDate
            hasOverdraft
            overdraftLimit
            highestCreditUtilisation
            isNewAccount
            isClosed
            createdAt
            updatedAt
            progressID
            _version
            _deleted
            _lastChangedAt
            owner
            __typename
          }
          nextToken
        }
        assets {
            items {
                id
                assetType
                joint
                institution
                description
                balance
                increasesFrequency
                increases
                applicantID
                observeMID
                currency
                accountNumber
                accountName
                accountAddress
                lastDocumentDate
                isNewAccount
                isClosed
                readAccessGroup
                editAccessGroup
                progressID
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                owner
            }
            nextToken
            startedAt
        }
        properties {
            items {
                id
                toBeSold
                residingHere
                propertyType
                address
                estimatedValue
                isRented
                rentPerAnnum
                rentPerMonth
                isMortgaged
                accountNumber
                outstanding
                monthlyRepayments
                remainingTerm
                
                lender
                inArrears
                arrears
                applicantID
                bedrooms
                bathrooms
                isRestructured
                originalAmount
                
                observeMID
                endDate
                currency
                lastDocumentDate
                readAccessGroup
                editAccessGroup
                progressID
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                owner
            }
            nextToken
            startedAt
        }
        debts {
            items {
                id
                debtType
                lender
                outstanding
                monthlyPayment
                creditLimit
                highestCreditUtilisation
                inArrears
                arrears
                endDate
                originalAmount
                currency
                clearedBeforeMortgage
                applicantID
                accountNumber
                observeMID
                accountNumber
                isNewAccount
                isClosed
                lastDocumentDate
                readAccessGroup
                editAccessGroup
                progressID
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                owner
            }
            nextToken
            startedAt
        }
      
        alternateEmailAddresses {
            items {
                id
                email
                applicantID
                readAccessGroup
                editAccessGroup
                createdAt
                updatedAt
                _version
                _deleted
                _lastChangedAt
                owner
            }
            nextToken
            startedAt
        }
        readAccessGroup
        editAccessGroup
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        owner
    }
    notes {
        items {
            id
            body
            author
            pinned
            deleted
            usermortgageID
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
        }
        nextToken
        startedAt
    }
    settings {
        id
        initialContactOn
        initialContactBy
        mortgageID
        contactTimes
        markedLead
        markedLeadBy
        markedSetupDone
        markedSetupDoneBy
        markedApplyDone
        markedApplyDoneBy
        markedComplete
        markedCompleteBy
        markedPreApproved
        markedPreApprovedBy
        markedApproved
        markedApprovedBy
        markedDocsSigned
        markedDocsSignedBy
        markedSubmitted
        markedSubmittedBy
        markedSuspended
        markedSuspendedBy
        offlineLead
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
    }
    solicitor {
        id
        firmName
        firmAddress
        contactName
        contactEmail
        contactPhone
        readAccessGroup
        editAccessGroup
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        owner
    }
    dynamicSections {
        items {
            id
            sectionStage
            sectionType
            sectionName
            sectionIndex
            sectionTitle
            sectionInstructions
            mortgageID
            observeMID
            emailReplyID
            progressID
            readAccessGroup
            editAccessGroup
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            owner
        }
        nextToken
        startedAt
    }
    tasks {
        items {
            id
            body
            author
            pinned
            due
            deleted
            target
            targetStarted
            targetLastActive
            priority
            completedOn
            completedBy
            paused
            closedOn
            closedBy
            folder
            userFolder
            observedBy
            userSortPosition
            tags
            pauses
            currentOwner
            lastMessageBy
            lastMessageOn
            lastMessage
            usermortgageID
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
        }
        nextToken
        startedAt
    }
    stageTasks {
        items {
            id
            mortgageID
            stage
            name
            deleted
            due
            completedOn
            completedBy
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
        }
        nextToken
        startedAt
    }
    invitations {
        items {
            id
            mortgageID
            applicant2ID
            firstName
            email
            inviter
            inviterFirstName
            sent
            accepted
            invalidated
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            owner
        }
        nextToken
        startedAt
    }
    UserMortgageDocuments {
        items {
            id
            title
            description
            identityID
            identityID2
            folder
            fileName
            fileExtension 
            isDynamic       
            name
            stage
            private
            mortgageID
            submissionID
            readAccessGroup
            editAccessGroup
            versionNo
            createdAt
            updatedAt
            _version
            _deleted
            _lastChangedAt
            owner
        }
        nextToken
        startedAt
    }
    readAccessGroup
    editAccessGroup
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    userMortgageRequirementId
    userMortgagePropertyId
    userMortgageExistingId
    userMortgageNeedsId
    userMortgageSettingsId
    userMortgageSolicitorId
    owner
`)
    const variables = {id}

    return performGQL(variables, query)
}

export default getMortgage